import { useEffect, useState } from 'react';

/**
 * Determining scroll behavior based on inView state.
 * Returns 'instant' if not in view, otherwise 'smooth' (e.g. when user clicks on a program).
 */
const useScrollBehavior = (inView: boolean) => {
    const [scrollBehavior, setScrollBehavior] = useState<'instant' | 'smooth'>('smooth');

    useEffect(() => {
        if (!inView) {
            setScrollBehavior('instant');
        } else {
            setScrollBehavior('smooth');
        }
    }, [inView]);

    return scrollBehavior;
};

export default useScrollBehavior;
